export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7127.0c236553.jpg";